import { defineNuxtPlugin } from '#app'
// import { maybeOptInToNextLayer } from '#core/utils/next-layers'

// Please read apps/docs/src/platform/feature-flags.md before using this feature.
export default defineNuxtPlugin({
  name: 'next-layers',
  // Depend on `feature-flags` so flags are already loaded (for both anonymous and
  // logged-in users, on server and client) before any layer opt-in is evaluated.
  // The `feature-flags` plugin itself depends on `pinia`, so ordering is transitive.
  dependsOn: ['feature-flags'],
  async setup() {
    // maybeOptInToNextLayer({
    //   featureFlag: 'your-feature-flag',
    //   paths: ['your-path'],
    // })
  },
})
